import { Breadcrumb, NavDropdown } from 'react-bootstrap';
import logoPreto from '../../assets/icons/logo_preto.svg';
import logoStrong from '../../assets/icons/logo-strong.svg';
import { useTranslation } from "react-i18next";
import pt from '../../assets/icons/pt-br.svg';
import es from '../../assets/icons/es.svg';
import en from '../../assets/icons/en.svg';
import './UniHeader.scss';
import { useUserStore } from '../../store/user';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBell, faClose, faExclamation } from '@fortawesome/free-solid-svg-icons';
import UniModalUser from '../UniModalUser/UniModalUser';
import { useState, useEffect } from 'react';
import { NotificationData, getNotifications, putNotifications } from '../../services/notificationService';

interface UniHeaderProps {
    activeRoute?: string;
    logout: () => void;
}

const UniHeader = (props: UniHeaderProps) => {
    const [showUserModal, setShowUserModal] = useState(false);    
    const [showNotifications, setShowNotifications] = useState(false);    
    const [notifications, setNotifications] = useState<NotificationData | undefined>();    
    const { i18n, t } = useTranslation();
    const { loginData, changeLng, darkMode, changeDarkMode, changeSelectedCustomer, selectedCustomer } = useUserStore();
    const changeLang = (lngCode: string) => {
        changeLng(lngCode);
        i18n.changeLanguage(lngCode);        
    }

    const doLogout = () => {
        localStorage.clear();
       props.logout();
    }

    const changeTheme = () => {
        changeDarkMode(!darkMode);
    }

    const closeUserModal = () => {
        setShowUserModal(false);
    }

    useEffect(() => {
        //getNotificationsHeader();
    }, [window.location.pathname]);

    useEffect(() => {
        if (showNotifications && (notifications?.notificationList?.some(n => n.notifications?.some(no => !no.isVisualized) ?? false) ?? false)) {
            putNotifications(loginData.email)
            .then(r => {
                if (r.success) getNotificationsHeader();
            })
            .catch(e => console.log(e))
        }
    }, [showNotifications]);
    
    const getNotificationsHeader = () => {
        getNotifications(loginData.email).then(r => setNotifications(r?.data)).catch(e => console.log(e));
    }

    window.addEventListener('click', function(e){   
        if (e !== null) {
            const el = e.target;
            if (el instanceof Node && !document.getElementById('notifications')?.contains(el)) {
              setShowNotifications(false);
            }
        }
      });

    return (
        <>
            <header>
                <div>
                    <div>
                        <img src={darkMode ? logoStrong : logoPreto} width={96} className='me-lg-5' alt='logo Unipar'/>
                    </div>

                    <div className='divider'></div>

                    <Breadcrumb>
                        <Breadcrumb.Item href="#">{t('welcome')}</Breadcrumb.Item>
                    </Breadcrumb>
                </div>

                <div className='icons'>
                    {/* <div className='notification' id='notifications'>
                        <FontAwesomeIcon 
                            icon={faBell} 
                            className='me-4 icon-notification'
                            onClick={() => setShowNotifications(!showNotifications)}
                        />
                        {(notifications?.qntNotVisualized ?? 0) > 0 && (<span className='badge' onClick={() => setShowNotifications(!showNotifications)}>{notifications?.qntNotVisualized}</span>)}
                        <div className='notification-body' style={showNotifications ? {opacity: 1, visibility: 'visible'} : {opacity: 0, visibility:'hidden'}}>
                            <div className='notification-header'>
                                <p>{t('notifications')}</p>
                                <FontAwesomeIcon icon={faClose} onClick={() => setShowNotifications(false)}/>
                            </div>
                            {
                                notifications?.notificationList?.map(notification => (
                                    <div className='notification-text-wrapper'>
                                        <div className='notification-icon' style={!notification?.notifications?.[0]?.isVisualized ? {backgroundColor: '#FF6636'} : {}}>
                                            <FontAwesomeIcon icon={faExclamation} />
                                        </div>
                                        <div className='notification-text'>
                                            <p className='notification-msg'>{notification?.notifications?.filter(n => n.lang === i18n.language.toUpperCase())?.[0]?.message ?? '-'}</p>
                                        </div>
                                    </div>
                                ))
                            }
                        </div>
                    </div> */}
                    <div className='dropdown-m'>
                        <NavDropdown title={loginData.name ?? 'Cliente'}>                            
                            <div className='f-check'>
                                <div className='lng' onClick={() => changeLang('pt')}>
                                    <img src={pt} alt='pt-br'/>
                                    <span>PT</span>
                                </div>
                                <div className='lng' onClick={() => changeLang('es')}>
                                    <img src={es} alt='es'/>
                                    <span>ES</span>
                                </div>
                                <div className='lng' onClick={() => changeLang('en')}>
                                    <img src={en} alt='en'/>
                                    <span>EN</span>
                                </div>
                            </div>
                            <NavDropdown.Divider />
                            {/* <NavDropdown.Item onClick={() => setShowUserModal(true)}>
                                {t('users')}
                            </NavDropdown.Item> */}
                            <NavDropdown.Item onClick={() => doLogout()}>
                                {t('logout')}
                            </NavDropdown.Item>
                        </NavDropdown>
                    </div>
                </div>
            </header>

            {/* <UniModalUser show={showUserModal} onHide={() => closeUserModal()}/> */}
        </>
    )
};

export default UniHeader;